export default __webpack_public_path__ + "static/media/breakfast-overlay-lyte.e0f021ef.png";